import React from "react";
import Title from "../Blocks/Title";
import Text from "../Blocks/Text";
import styles from "./Normal.module.css";
export default function Normal({ id, data }) {
	return (
		<div id={id} className={styles.normal}>
			<div className={styles.title}>
				<Title title={data.title} alignment={data.alignTitle} />
			</div>
			<div className={styles.text}>
				<Text content={data.content} alignment={data.alignContent} />
			</div>
		</div>
	);
}
